
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#A8B5A0] text-white py-16 px-8 lg:px-16">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="text-2xl font-light mb-4" style={{ fontFamily: 'Georgia, serif' }}>
              Serenity Massage
            </h3>
            <p className="text-sm text-white/80 leading-relaxed">
              Healing through therapeutic touch and mindful care.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button onClick={() => scrollToSection('home')} className="hover:text-white/70 transition-colors duration-300 cursor-pointer">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('about')} className="hover:text-white/70 transition-colors duration-300 cursor-pointer">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('features')} className="hover:text-white/70 transition-colors duration-300 cursor-pointer">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="hover:text-white/70 transition-colors duration-300 cursor-pointer">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm uppercase tracking-wider mb-4">Connect</h4>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:4372194574" className="hover:text-white/70 transition-colors duration-300 cursor-pointer">
                  (437) 219-4574
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:oxzyenbeautyandwellness@gmail.com" className="hover:text-white/70 transition-colors duration-300 cursor-pointer">
                  oxzyenbeautyandwellness@gmail.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>77 Main Street N, Brampton, ON, L6X 1M8</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/20 text-center text-sm text-white/70">
          <p>© 2025 Serenity Massage. All rights reserved. | <a href="https://readdy.ai/?ref=logo" className="hover:text-white transition-colors duration-300 cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
}
